import {
  postersFetchAPoster,
  postersIsThereMorePosters,
  postersGetMargin,  
  postersGetPosterResposiveWidth,
  getPostersMaximumImageWidth,
  postersSetPosterResposiveWidth,
  postersResetResolve,
  postersSetPostersIndexAndCursor,
  postersSetPostersFilter,
  postersSetRegionTownFilter,
  postersGetPostersIndex,
  posterGetCursorByAbsoluteIndex
} from "./posters.js";

import { posterCreateAndAppend } from "./poster.js";

import { browserGetBrowserWidth, browserImageIsReady } from "./browser.js";
import { adsenseAddAndPush, ADSENSE_MAXIMUM_WIDTH } from "./adsense.js";
import { controlSentinelIsVisible, controlSetCallback } from "./control.js";
import { analyticsPush } from "./analytics.js";

const PAGE_MINIMUM_POSTER_NUMBER = 5;
const PAGE_MAXIMUM_POSTER_NUMBER = 20;

let pageLines = 0;
let _pageCurrentLineWidth = 0;
let _pageHiddenPosterWrapper = null;
let _pagePostersNumber = 0;
let _pagePostersImagesNumber = 0;
// var pagePostersArray = [];
let pagePostersResolve;
let pagePostersReject;
let _pagePostersFilter;
let pageFetchNumber = 0;
let _pageNoPoster = false;

let _pageAdsNumber = 0;
let _pagePostersTown;
let _pagePostersRegion;

let _pageMinimumPostersNumber = PAGE_MINIMUM_POSTER_NUMBER;
let _pageEndingLine = false;

let _pageWrapper;

function pagePxSizeToInt(css) {
  return parseInt(css.replace("px", ""));
}

function _pageResetLine() {
  _pageCurrentLineWidth = 0;
  _pageHiddenPosterWrapper = null;
  _pageEndingLine = false;
  _pageNoPoster = false;
}

function pageIsNewLine(width) {
  // margins = 16 *4
  _pageCurrentLineWidth += width + postersGetMargin();

  // console.log("lineWidth ", _pageCurrentLineWidth);

  if (_pageCurrentLineWidth > browserGetBrowserWidth()) {
    pageLines++;
    _pageCurrentLineWidth = width + postersGetMargin();
    return true;
  }
  return false;
}

function pageFetch(pageElement) {
  postersFetchAPoster(null, null)
    .then((th) => {
      pageFetchNumber++;
      if (th.poster !== null) {
        _pagePostersNumber++;
        //
        let wrapper = posterCreateAndAppend(th.poster, pageElement);
        let image = wrapper.getElementsByClassName("posterImage")[0];

        //
        // if it is endding the line no new ads
        if (_pagePostersNumber >= _pageMinimumPostersNumber === false) {
          if (Math.floor(_pagePostersNumber / 3) > _pageAdsNumber) {
            _pageAdsNumber++;
            adsenseAddAndPush(
              pageElement,
              postersGetPosterResposiveWidth(ADSENSE_MAXIMUM_WIDTH)
            );
          }
        }

        // this can be asynchronous ----------------------------------------
        browserImageIsReady(image)
          .then(() => {
            _pagePostersImagesNumber++;

            //
            let maximumImageWidth = getPostersMaximumImageWidth(
              image.naturalWidth,
              image.naturalHeight
            );
            postersSetPosterResposiveWidth(wrapper, maximumImageWidth);

            //
            if (_pagePostersImagesNumber >= _pageMinimumPostersNumber) {
              if (controlSentinelIsVisible() === true) {
                if (pageFetchMorePosters() === true) {
                  return;
                }
              }

              // cal aquesta funcio??? o es priscndile
              if (pageAreAllImageWidthAvailable() === true) {
                if (pageIsLineFinished(wrapper) === false) {
                  pageFetch(pageElement);
                  return;
                }
              }

              if (_pageMinimumPostersNumber >= PAGE_MAXIMUM_POSTER_NUMBER) {
                pageFetchEnd(true);
                return;
              }
            }
          })
          .catch((err) => {
            pagePostersReject(err);
          });
      } else {
        _pageNoPoster = true;
      }
      // Wait 5 fetches to return there are no all the posters asked
      if (
        pageFetchNumber >= _pageMinimumPostersNumber &&
        _pageNoPoster === true
      ) {
        pageFetchEnd(false);
      }
    })
    .catch((err) => {
      pagePostersReject(err);
    });
}

function pageAreAllImageWidthAvailable() {
  let auxItems = _pageWrapper.getElementsByClassName("mainItem");
  return [].every.call(auxItems, (item) => item.style.width !== "");
}

function pageIsLineFinished(wrapper) {
  if (_pageEndingLine === true) {
    if (pageIsNewLine(pagePxSizeToInt(wrapper.style.width)) === true) {
      _pageHiddenPosterWrapper = wrapper;
      wrapper.style.display = "none";
      controlSetCallback(pageFetchMorePosters);
      return true;
    }
  } else {
    // finishing the last line ---------------------------------
    let auxItems = _pageWrapper.getElementsByClassName("mainItem");
    [].forEach.call(auxItems, (item) => {
      pageIsNewLine(pagePxSizeToInt(item.style.width));
    });

    _pageEndingLine = true;
  }
  return false;
}

function pageFetchMorePosters() {
  if (_pageMinimumPostersNumber < PAGE_MAXIMUM_POSTER_NUMBER) {
    // reset ending line
    _pageCurrentLineWidth = 0;
    _pageEndingLine = false;

    //
    if (_pageHiddenPosterWrapper !== null) {
      // hideen poster has been already contabilised
      _pageHiddenPosterWrapper.style.display = "block";
      _pageHiddenPosterWrapper = null;
    }

    _pageMinimumPostersNumber = _pagePostersNumber;

    // at least one more
    let newPageFetch = 0;
    do {
      pageFetch(_pageWrapper);
      _pageMinimumPostersNumber++;
      newPageFetch++;
      if (newPageFetch === 4) break;
    } while (_pageMinimumPostersNumber < PAGE_MAXIMUM_POSTER_NUMBER);

    analyticsPush("event", _pageMinimumPostersNumber.toString(), {
      event_category: "Posters Number"
    });

    return true;
  }
  return false;
}

function pageFetchEnd(final) {
  if (_pageAdsNumber === 0) {
    let ads = document.getElementsByClassName("mainAdWrapper");
    if (ads.length > 0) {
      adsenseAddAndPush(ads[0]);
      _pageAdsNumber++;
    }
  }
  pagePostersResolve(final);
}

function pageFetchPosters(wrapper, region, town, label, index, cursor = "") {
  postersResetResolve();
  _pageResetLine();
  postersSetPostersIndexAndCursor(index, cursor);
  postersSetPostersFilter(label);
  postersSetRegionTownFilter(region, town);
  _pagePostersFilter = label;
  _pagePostersRegion = region;
  _pagePostersTown = town;
  //
  window.addEventListener("resize", function (event) {
    let auxPosters = document.getElementsByClassName("mainItem");
    [].forEach.call(auxPosters, (poster) => {
      let auxImages = poster.getElementsByClassName("posterImage");
      let width;
      if (auxImages.length !== 0) {
        width = auxImages[0].naturalWidth;
      } else {
        width = ADSENSE_MAXIMUM_WIDTH;
      }
      postersSetPosterResposiveWidth(poster, width);
    });
  });
  //
  return new Promise(function (resolve, reject) {
    pagePostersResolve = resolve;
    pagePostersReject = reject;
    _pageWrapper = wrapper;
    // fetches 5 posters and ends the line
    pageFetch(wrapper);
    pageFetch(wrapper);
    pageFetch(wrapper);
    pageFetch(wrapper);
    pageFetch(wrapper);
  });
}

function pageIsThereMorePosters() {
  if (
    _pageHiddenPosterWrapper !== null ||
    postersIsThereMorePosters() === true
  ) {
    return true;
  }
  return false;
}

function pageGetNextPageHref() {
  let currentIndex = postersGetPostersIndex();
  if (_pageHiddenPosterWrapper !== null) {
    currentIndex--;
  }
  let ret = `/?v=${process.env.APP_VERSION}&index=${currentIndex}`;
  if (_pagePostersFilter !== "") ret += "&label=" + _pagePostersFilter;
  if (_pagePostersTown !== "") ret += "&town=" + _pagePostersTown;
  if (_pagePostersRegion !== "") ret += "&region=" + _pagePostersRegion;

  let cursor = posterGetCursorByAbsoluteIndex(currentIndex);
  if (cursor !== null) {
    ret += "&cursor=" + cursor;
  }

  return ret;
}

function pageGetPostersNumber() {
  return _pagePostersNumber;
}

export {
  pageGetPostersNumber,
  pageFetchPosters,
  pageIsThereMorePosters,
  pageGetNextPageHref,
  pagePxSizeToInt
};
